import { Box, Dialog, DialogContent, DialogTitle, IconButton, Typography } from '@material-ui/core';
import { SpeakerNotes } from '@material-ui/icons';
import React, { useState } from 'react';

export interface ApplicationResponse {
  question: { activityApplicationQuestionId: string; label: string };
  answer: string;
}

export const ApplicationResponsesCell = ({ answers }: { answers?: ApplicationResponse[] }) => {
  const [open, setOpen] = useState(false);

  if (!answers || answers.length === 0) {
    return null;
  }

  return (
    <>
      <IconButton
        size='small'
        aria-label='View application responses'
        onClick={(e) => {
          e.stopPropagation();
          setOpen(true);
        }}
      >
        <SpeakerNotes fontSize='small' style={{ color: '#646464' }} />
      </IconButton>

      <Dialog open={open} maxWidth='sm' fullWidth onClose={() => setOpen(false)}>
        <DialogTitle>{'Application responses'}</DialogTitle>
        <DialogContent>
          {answers.map((response) => (
            <Box key={response.question.activityApplicationQuestionId} marginBottom={2}>
              <Typography variant='subtitle2' style={{ fontWeight: 600 }}>
                {response.question.label}
              </Typography>
              <Typography variant='body2' color='textSecondary'>
                {response.answer}
              </Typography>
            </Box>
          ))}
        </DialogContent>
      </Dialog>
    </>
  );
};
